import { Typography } from "@mui/material";

interface ProfileSectionTitleProps {
  children: React.ReactNode;
}

export function ProfileSectionTitle({ children }: ProfileSectionTitleProps) {
  return (
    <Typography
      variant="overline"
      sx={{
        color: "var(--color-dark-dust)",
        fontWeight: 600,
        fontSize: "11px",
        letterSpacing: "0.06em",
        display: "block",
        mb: 2,
      }}
    >
      {children}
    </Typography>
  );
}
